import React, { useState, useEffect } from 'react';
import { fetchSalesPopup, updateSalesPopup, createSalesPopup } from '../../services/AdminSalesPopupService';
import '../../styles/settings/SalesPopupConfigForm.css';

const SalesPopupConfigForm = () => {
  const [formData, setFormData] = useState({
    title: 'Get $50 OFF your next booking with us',
    subtitle: 'Book your Miami boat adventure today and enjoy $50 off — our gift to you!',
    button_text: '🎟️ Claim My $50 OFF',
    trust_item_1: 'Instant Discount',
    trust_item_2: 'No Hidden Fees',
    trust_item_3: 'Secure & Fast',
    enabled: false,
  });
  const [popupId, setPopupId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    loadPopupConfig();
  }, []);

  const loadPopupConfig = async () => {
    try {
      setLoading(true);
      setError('');
      const config = await fetchSalesPopup();
      if (config && config.id) {
        setFormData({
          title: config.title || 'Get $50 OFF your next booking with us',
          subtitle: config.subtitle || 'Book your Miami boat adventure today and enjoy $50 off — our gift to you!',
          button_text: config.button_text || '🎟️ Claim My $50 OFF',
          trust_item_1: config.trust_item_1 || 'Instant Discount',
          trust_item_2: config.trust_item_2 || 'No Hidden Fees',
          trust_item_3: config.trust_item_3 || 'Secure & Fast',
          enabled: config.enabled || false,
        });
        setPopupId(config.id);
      } else {
        // No hay configuración, mantener los valores por defecto
        setPopupId(null);
      }
    } catch (error) {
      console.error('Error loading popup config:', error);
      // Si es un 404, no hay configuración (normal)
      if (error.message && error.message.includes('404')) {
        setPopupId(null);
      } else {
        setError('Error loading configuration. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
    setMessage('');
    setError('');
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    setError('');

    try {
      if (popupId) {
        await updateSalesPopup(popupId, formData);
        setMessage('Sales popup configuration updated successfully!');
      } else {
        const newConfig = await createSalesPopup(formData);
        setPopupId(newConfig.id);
        setMessage('Sales popup configuration created successfully!');
      }
      // Recargar después de un momento
      setTimeout(() => {
        loadPopupConfig();
      }, 1000);
    } catch (error) {
      console.error('Error saving popup config:', error);
      setError(error.message || 'Error saving configuration. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="sales-popup-config-loading">Loading configuration...</div>;
  }

  return (
    <div className="sales-popup-config-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="enabled" className="checkbox-label">
            <input
              type="checkbox"
              id="enabled"
              name="enabled"
              checked={formData.enabled}
              onChange={handleChange}
            />
            Enable Sales Popup
          </label>
        </div>

        <div className="form-group">
          <label htmlFor="title">Title (Headline)</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            maxLength={200}
            placeholder="Get $50 OFF your next booking with us"
          />
          <small className="character-count">{formData.title.length}/200 characters</small>
        </div>

        <div className="form-group">
          <label htmlFor="subtitle">Subtitle (Subheadline)</label>
          <textarea
            id="subtitle"
            name="subtitle"
            value={formData.subtitle}
            onChange={handleChange}
            required
            maxLength={300}
            rows={3}
            placeholder="Book your Miami boat adventure today and enjoy $50 off — our gift to you!"
          />
          <small className="character-count">{formData.subtitle.length}/300 characters</small>
        </div>

        <div className="form-group">
          <label htmlFor="button_text">Button Text</label>
          <input
            type="text"
            id="button_text"
            name="button_text"
            value={formData.button_text}
            onChange={handleChange}
            required
            maxLength={100}
            placeholder="🎟️ Claim My $50 OFF"
          />
          <small className="character-count">{formData.button_text.length}/100 characters</small>
        </div>

        <div className="form-group">
          <label htmlFor="trust_item_1">Trust Indicator 1</label>
          <input
            type="text"
            id="trust_item_1"
            name="trust_item_1"
            value={formData.trust_item_1}
            onChange={handleChange}
            required
            maxLength={18}
            placeholder="Instant Discount"
          />
          <small className="character-count">{formData.trust_item_1.length}/18 characters</small>
        </div>

        <div className="form-group">
          <label htmlFor="trust_item_2">Trust Indicator 2</label>
          <input
            type="text"
            id="trust_item_2"
            name="trust_item_2"
            value={formData.trust_item_2}
            onChange={handleChange}
            required
            maxLength={18}
            placeholder="No Hidden Fees"
          />
          <small className="character-count">{formData.trust_item_2.length}/18 characters</small>
        </div>

        <div className="form-group">
          <label htmlFor="trust_item_3">Trust Indicator 3</label>
          <input
            type="text"
            id="trust_item_3"
            name="trust_item_3"
            value={formData.trust_item_3}
            onChange={handleChange}
            required
            maxLength={18}
            placeholder="Secure & Fast"
          />
          <small className="character-count">{formData.trust_item_3.length}/18 characters</small>
        </div>

        <button className="button" type="submit" disabled={saving}>
          {saving ? 'Saving...' : popupId ? 'Update Configuration' : 'Create Configuration'}
        </button>
      </form>
      {message && <p className="message">{message}</p>}
      {error && <p className="message error-message">{error}</p>}
    </div>
  );
};

export default SalesPopupConfigForm;

